import {GlobalVariables} from "../GlobalVariables";
import Header from "./Header";
import {gsap} from "../LibrariesImport";

export default class NavsFull {
    static init() {
        this.header = document.querySelector(".header-main-full");

        // Détecte le mobile OU le mode forcé via la classe Twig OU si on est sur une page archive
        const isArchivePage = document.body.classList.contains('archive') ||
            document.body.classList.contains('post-type-archive');
        const isSingleProject = document.body.classList.contains('single-project_detailed') ||
                               document.body.classList.contains('single-project_lab');
        const isArchiveProject = Header.isProjectArchive();

        this.isBurgerMode = window.innerWidth <= 991 ||
            (this.header && this.header.classList.contains('force-burger-mode')) ||
            isArchivePage ||
            isArchiveProject ||
            isSingleProject;

        if (this.header) {
            this.overlay = this.header.querySelector(".overlay");
            this.navBg = this.header.querySelector(".nav-main-bg");
            this.toggleMobileNav(); // Initialise le clic sur le bouton burger
            this.initOutsideClickClose();
            this.initMegaMenu();
            GlobalVariables.resizeCallbacks.push(this);
        }
    }

    static toggleMobileNav() {
        const openTrigger = document.querySelector(".nav-main-toggle");
        if (openTrigger) {
            openTrigger.addEventListener("click", () => {
                if (document.body.classList.contains("navs-open")) {
                    this.closeMobileNav();
                } else {
                    this.openMobileNav();
                }
            });
        }
    }

    static openMobileNav() {
        if (Header.isProjectArchive()) {
            Header.closeFilterPanel();
        }

        document.body.classList.add("navs-open");
        Header.makeHeaderAsBannerTheme();

        // GlobalVariables.lenis?.stop();
    }

    static closeMobileNav() {
        document.body.classList.remove("navs-open");
        Header.restoreHeaderTheme();

        const activeMenuItems = this.header.querySelectorAll(".menu-item-lev1.active");
        activeMenuItems.forEach(item => {
            item.classList.remove("active");
            const subnav = item.querySelector(".lev2");
            if( subnav ) {
                subnav.classList.remove("show");
            }
        });

        // GlobalVariables.lenis?.start();
    }

    static initOutsideClickClose() {
        if (this.outsideClickBound) {
            return;
        }

        this.outsideClickBound = true;
        this.navContainer = this.header.querySelector(".header-main-navs");

        document.addEventListener("click", (event) => {
            const isDesktop = window.innerWidth >= 992;
            const isArchiveProject = Header.isProjectArchive();
            const isSingleProjectDetailed = document.body.classList.contains('single-project_detailed');
            const isNavOpen = document.body.classList.contains("navs-open");
            const clickedInsideNav = this.navContainer && this.navContainer.contains(event.target);

            if (isDesktop && (isArchiveProject || isSingleProjectDetailed) && isNavOpen && !clickedInsideNav) {
                this.closeMobileNav();
            }
        });
    }

    static initMegaMenu() {
        // CORRECTION : On vérifie que l'overlay existe avant d'ajouter l'événement
        if (this.overlay) {
            this.overlay.addEventListener("click", () => {
                this.closeAllLev2();
            });
        }

        this.navMain = this.header.querySelector(".nav-main");

        // Sécurité supplémentaire : si navMain n'existe pas, on arrête tout
        if (!this.navMain) return;

        this.levelOneItems = this.navMain.querySelectorAll(".menu-item-lev1.menu-item-has-children");

        this.levelOneItems.forEach(levelOne => {
            levelOne.toggle = levelOne.querySelector("button[data-header='toggler']");
            levelOne.levelTwo = levelOne.querySelector(".lev2-items");

            if (!levelOne.levelTwo) {
                return;
            }

            levelOne.toggle.addEventListener("click", (e) => {
                e.preventDefault();

                if (levelOne.classList.contains("active")) {
                    Header.restoreHeaderTheme();

                    this.navMain.classList.remove("subnav-active");
                    this.adjustNavBg(levelOne.levelTwo);
                    levelOne.classList.remove("active");
                    levelOne.levelTwo.classList.remove("show");
                    levelOne.toggle.setAttribute("aria-expanded", false);

                    if (!this.isBurgerMode) {
                        // GlobalVariables.lenis?.start();
                    }
                } else {
                    this.closeAllLev2();

                    Header.makeHeaderAsBannerTheme();
                    this.navMain.classList.add("subnav-active");
                    this.adjustNavBg(levelOne.levelTwo);
                    levelOne.classList.add("active");
                    levelOne.levelTwo.classList.add("show");
                    levelOne.toggle.setAttribute("aria-expanded", true);

                    if (!this.isBurgerMode) {
                        // GlobalVariables.lenis?.stop();
                    }
                }
            });
        });
    }

    static closeAllLev2() {
        Header.restoreHeaderTheme();

        // Sécurité : Vérifier si navMain existe avant d'accéder à sa classList
        if (this.navMain) {
            this.navMain.classList.remove("subnav-active");
        }

        // Sécurité : Vérifier si levelOneItems a été peuplé
        if (this.levelOneItems) {
            this.levelOneItems.forEach(item => {
                item.classList.remove("active");
                if (item.levelTwo) item.levelTwo.classList.remove("show");
                const toggler = item.querySelector("button[data-header='toggler']");
                if (toggler) toggler.setAttribute("aria-expanded", "false");
            });
        }

        if (!this.isBurgerMode) {
            // GlobalVariables.lenis?.start();
        }
    }

    static restoreNav() {
        this.closeAllLev2();
        this.closeMobileNav();
    }

    static adjustNavBg(levelTwo) {
        if (!this.isBurgerMode) {
            const navBg = this.header.querySelector(".nav-main .nav-main-bg");
            // Sécurité pour l'animation GSAP
            if (navBg && levelTwo) {
                gsap.to(navBg, {duration: 0.3, height: levelTwo.offsetHeight});
            }
        }
    }

    static resize() {
        // Recalcule isBurgerMode en incluant la détection de page archive
        const isArchivePage = document.body.classList.contains('archive') ||
            document.body.classList.contains('post-type-archive');
        const isSingleProject = document.body.classList.contains('single-project_detailed') ||
                               document.body.classList.contains('single-project_lab');
        const isArchiveProject = Header.isProjectArchive();
        
        const previousMode = this.isBurgerMode;
        this.isBurgerMode = window.innerWidth <= 991 ||
            (this.header && this.header.classList.contains('force-burger-mode')) ||
            isArchivePage ||
            isArchiveProject ||
            isSingleProject;

        // Ne restaure la nav que si on change réellement de mode
        if (previousMode !== this.isBurgerMode) {
            this.restoreNav();
        }
    }
}
